import type { LeadStage } from "@school-sales-ai/shared";
import { usePipelineStagesQuery } from "@/hooks/usePipelineStages";
import { StagePill } from "./StagePill.js";

type Props = {
  current: LeadStage;
  onSelect: (stage: LeadStage) => void;
  onClose: () => void;
};

export function StageSheet({ current, onSelect, onClose }: Props): React.JSX.Element {
  const { data: stages } = usePipelineStagesQuery();
  return (
    <div
      className="absolute inset-0 z-50 flex flex-col justify-end bg-black/30"
      onClick={onClose}
    >
      <div
        className="bg-white rounded-t-2xl max-h-[70%] overflow-y-auto animate-sheet-up"
        onClick={(e) => e.stopPropagation()}
      >
        {/* Handle */}
        <div className="flex justify-center pt-4 pb-2">
          <div className="w-10 h-1 rounded-full bg-ink-100" />
        </div>
        <div className="font-display font-bold text-[18px] text-ink-900 px-5 pb-3">
          Cambiar etapa
        </div>
        {(stages ?? []).map((stage) => (
          <button
            key={stage.key}
            type="button"
            onClick={() => onSelect(stage.key)}
            className={`flex w-full items-center justify-between px-5 py-3.5 border-b border-ink-050 cursor-pointer ${
              stage.key === current ? "bg-lime-pale" : "bg-white"
            }`}
          >
            <StagePill stage={stage.key} />
            {stage.key === current && (
              <svg
                width="16"
                height="16"
                viewBox="0 0 24 24"
                fill="none"
                stroke="oklch(0.33 0.125 16)"
                strokeWidth="2.5"
                strokeLinecap="round"
                aria-hidden="true"
              >
                <polyline points="20 6 9 17 4 12" />
              </svg>
            )}
          </button>
        ))}
        <div className="h-6" />
      </div>
    </div>
  );
}
